import colorMod from 'color';
import { get } from 'lodash';

export default ({ margin, typography, fontSize, color }) => ({
  panel: {
    boxShadow: '0px 2px 8px #00000033',
    backgroundColor: '#ffffff',
    borderRadius: 5,
    height: '70%',
    maxHeight: 600,
    top: '50%',
    transform: 'translateY(-50%)',
    maxWidth: 1330,
    zIndex: 1002,
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    overflow: 'hidden',
    '@media only screen and (max-width: 960px)': {
      width: '100%',
    },
    '@media only screen and (min-width: 960px) and (max-width: 1280px)': {
      width: 'calc(100% - 72px)',
    },
    '@media only screen and (min-width: 1280px) and (max-width: 1600px)': {
      width: '83%',
    },
    '@media only screen and (min-width: 1600px)': {
      width: 1330,
    },
  },
  tooltipIcon: {
    height: 18,
    width: 18,
    marginLeft: 5,
    verticalAlign: 'middle',
    fill: color.primaryButtonBackground,
    stroke: color.primaryButtonText,
  },
  toolTip: {
    fontSize: fontSize.smallText,
  },
  panelModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
  },
  overlay: {
    background: '#000000B3',
    width: '100%',
    position: 'fixed',
    height: '100%',
    zIndex: 1000,
    bottom: 0,
  },
  dataLimitView: {
    width: '70%',
  },
  placeholderText: {
    fontSize: fontSize.smallText,
  },
  maxGroupBysError: {
    fontSize: fontSize.small,
  },
  report: {
  },
  filterRankContainer: {
    height: '70%',
  },
  addMetricSelectBox: {
    display: 'inline-flex',
  },
  limitValue: {
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    float: 'right',
    marginRight: 22,
  },
  limitValueRed: {
    float: 'right',
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    marginRight: 22,
    color: 'red',
  },
  metricSelectFieldContainer: {
    marginBottom: '0px !important',
    marginTop: '0px !important',
  },
  metricSelectField: {
    marginBottom: '0px !important',
    marginTop: '0px !important',
  },
  metricSelectLabel: {
    display: 'none',
  },
  dataLimitContainer: {
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    marginLeft: 24,
    marginBottom: 8,
  },
  chartMetricLabel: {
    display: 'inline-block',
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.sectionTitle,
    marginRight: 12,
  },
  addFilterLabel: {
    display: 'inline-block',
    color: color.pageTitle,
    fontFamily: typography.pageTitle,
    fontSize: fontSize.sectionTitle,
  },
  panelHeader: {
    borderBottom: `1px solid ${color.borderColor}`,
    padding: '12px 12px 12px 22px',
    boxSizing: 'border-box',
  },
  panelBody: {
    backgroundColor: `${color.uiBackground} !important`,
    height: '74%',
    position: 'relative',
  },
  actionButtons: {
    display: 'flex',
    paddingRight: 20,
    justifyContent: 'flex-end',
    width: '36%',
  },
  getDataBtn: {
    backgroundColor: `${color.primaryButtonBackground} !important`,
    borderColor: `${color.primaryButtonBackground} !important`,
    borderRadius: 4,
    color: `${color.primaryButtonText} !important`,
    fontWeight: 'normal !important',
    fontFamily: `${typography.bodyText} !important`,
    marginRight: 10,
    '&:hover': {
      backgroundColor: `${color.primaryButtonHover} !important`,
      borderColor: `${color.primaryButtonHover} !important`,
    },
  },
  cancelBtn: {
    border: `1px solid ${color.primaryButtonBackground}`,
    background: color.primaryButtonText,
    color: color.primaryButtonBackground,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    borderRadius: 3,
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:focus': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      outline: 'none',
    },
    '&:active': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
  },
  panelFooter: {
    height: '16%',
    display: 'flex',
    alignItems: 'center',
    borderTop: `1px solid ${color.borderColor}`,
    background: '#F5F5F5 0% 0% no-repeat padding-box',
  },
  metricView: {
    display: 'inline-block',
    height: '100%',
    borderRight: `1px solid ${color.borderColor}`,
    width: '66%',
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 36,
    overflowX: 'scroll',
    boxSizing: 'border-box',
  },
  filterView: {
    display: 'inline-block',
    width: '34%',
    position: 'absolute',
    height: '100%',
    overflowY: 'scroll',
  },
  filterName: {
    height: 36,
    display: 'flex',
    cursor: 'pointer',
    paddingLeft: 16,
    alignItems: 'center',
    '&:hover': {
      background: '#F5FAFF 0% 0% no-repeat padding-box',
    },
  },
  addMetricContainer: {
    display: 'inline-block',
    width: '66%',
  },
  addFilterContainer: {
    alignItems: 'center',
    display: 'inline-flex',
    width: '30%',
    boxSizing: 'border-box',
    verticalAlign: 'middle',
  },
  createChartBtn: {
    backgroundColor: '#ffffff !important',
    borderColor: '#D8D8D8 !important',
    color: `${color.bodyText} !important`,
    fontSize: `${fontSize.buttonText} !important`,
    fontFamily: `${typography.bodyText} !important`,
    height: 36,
    fontWeight: 'normal',
    '&:focus': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.primaryButtonHover}`,
    },
  },
  backIcon: {
    fill: `${color.primaryButtonBackground} !important`,
    width: 23,
    cursor: 'pointer',
    height: 21,
    marginTop: 3,
    transform: 'rotate(90deg)',
    opacity: 1,
  },
  helpIcon: {
    fontSize: 20,
    margin: get(margin, 'm2'),
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
  },
  '@media only screen and (max-width: 1400px)': {
    metricView: {
      width: '60%',
    },
    filterView: {
      width: '40%',
    },
    dataLimitView: {
      width: '60%',
    },
    buttonBar: {
      width: '40%',
    },
    addMetricContainer: {
      width: '60%',
    },
    addFilterContainer: {
      width: '40%',
    },
  },
  '@media only screen and (max-width: 1170px)': {
    metricView: {
      width: '55%',
    },
    filterView: {
      width: '45%',
    },
    dataLimitView: {
      width: '55%',
    },
    buttonBar: {
      width: '45%',
    },
    addMetricContainer: {
      width: '55%',
    },
    addFilterContainer: {
      width: '45%',
    },
  },
});